module.exports = __webpack_public_path__ + "static/media/20210401_224542_802_IMG_0008.f83924df.jpg";